// @core/api/endpoints/booking/check_booking_availability.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckBookingAvailabilityRequest,
  CheckBookingAvailabilityResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Check booking availability
 * Checks if the requested time slot is available for a booking-aware entity type, considering the type's scheduling constraints (min_notice, max_days_ahead, buffer_between_bookings) and the resource's existing bookings.
 */
export async function CheckBookingAvailability(
  target_type: string,
  data: CheckBookingAvailabilityRequest,
  options?: RequestOptions
): Promise<CheckBookingAvailabilityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/check-availability`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  const requestOptions = options;
  return client.post<CheckBookingAvailabilityResponse>(requestPath, data, requestOptions);
}
